export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_FORMAT_2 = "MMM DD, YYYY";
export const TIME_FORMAT = "hh:mm A";
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
